export default __webpack_public_path__ + "static/media/Dead (2).ffefe398.png";